// extracted by mini-css-extract-plugin
module.exports = {"EventIcon":"EventIcon_EventIcon__G7455","EventIcon--SmallMobile":"EventIcon_EventIcon--SmallMobile___XsNw"};